//import { checkUserRoles } from '../Header/utils'

//const STATISTICS_ROLES = ['statistic_ssid', 'statistic_coupons', 'statistic_purchases', 'statistic_chromecast', 'statistic_home', 'statistics_customers'];

export const MENU_DASHBOARD = {
  label: 'header.dashboard',
  url: '/dashboard',
  key: 'dashboard',

  icon: 'objects-column'
}

export const MENU_SUPERVISION = {
  label: 'header.monitoring',
  key: 'supervision',
  icon: 'gauge-high',
  menu: [
    {
      label: 'header.monitoring_map',
      url: '/monitoring/map',
      key: 'map',
      requiredRoles: ['supervision']
    },
    {
      label: 'header.monitoring_sites',
      url: '/monitoring/sites',
      key: 'sites',
      requiredRoles: ['supervision']
    },
    {
      label: 'header.monitoring_ssids',
      url: '/monitoring/ssids',
      key: 'ssids',
      requiredRoles: ['supervision']
    },
    {
      label: 'header.monitoring_infras',
      url: '/monitoring/infras/hardwares',
      key: 'infras',
      requiredRoles: ['supervision']
    },
    {
      key: 'wan',
      label: 'header.wan',
      url: '/monitoring/wan',
      requiredRoles: ['wan', 'wan_expert']
    },
    {
      key: 'connected_users',
      label: 'header.connected_users',
      url: '/monitoring/connected-users',
      requiredRoles: ['connected_devices']
    },
    {
      key: 'topology',
      label: 'header.monitoring_topology',
      url: '/monitoring/topology',
      requiredRoles: ['topology']
    }
  ]
}

export const MENU_STATISTICS = {
  label: 'header.stats_globals',
  icon: 'square-poll-vertical',
  key: 'statistics',
  menu: [
    {
      url: '/stats/usage',
      label: 'navigation.stats_globals.usage.title',
      key: 'usage',
      requiredRoles: ['statistic_ssid']
    },
    {
      url: '/stats/codes',
      label: 'navigation.stats_globals.codes.title',
      key: 'codes',
      requiredRoles: ['statistic_coupons']
    },
    {
      url: '/stats/purchases',
      label: 'navigation.stats_globals.purchases.title',
      requiredRoles: ['statistic_purchases']
    },
    {
      url: '/stats/chromecasts',
      label: 'navigation.stats_globals.chromecasts.title',
      requiredRoles: ['statistic_chromecast']
    },
    {
      url: '/stats/customers',
      label: 'navigation.stats_globals.customers.title',
      requiredRoles: ['statistic_customers']
    },
    {
      url: '/stats/product-analytics',
      label: 'navigation.stats_globals.product_analytics.title',
      key: 'product_analytics',
      adminOnly: true
    }
  ]
}

export const MENU_DOCUMENTS = {
  label: 'header.documents',
  key: 'documents',
  icon: 'file',
  menu: [
    {
      url: '/documents/audin',
      label: 'navigation.documents.submenu.viewable.name',
      requiredRoles: ['documents_audin_audit', 'documents_audin_integration', 'documents_audin_technical_visit', 'documents_audin_revised_technical_visit']
    },
    {
      url: '/documents/center',
      label: 'navigation.documents.submenu.downloadable.name',
      requiredRoles: [
        'documents_support_documentation',
        'documents_financial_report',
        'documents_indicator_report',
        'documents_other_documents'
      ]
    }
  ]
}

export const MENU_WIFI = {
  label: 'navigation.wifi.title',
  key: 'wifi',
  icon: 'wifi',
  menu: [
    {
      url: '/codes/standard',
      label: 'navigation.wifi.code_standard.title',
      requiredRoles: ['codes']
    },
    {
      url: '/codes/h3',
      label: 'navigation.wifi.code_h3.title',
      requiredRoles: ['planet_campus']
    },
    {
      url: '/advertisements',
      label: 'navigation.wifi.advertisement.title',
      requiredRoles: ['portal_advertisement']
    },
    {
      url: '/ran',
      label: 'navigation.wifi.ran.title',
      requiredRoles: ['ran', 'ran_stime', 'ran_stime_ro']
    },
    {
      key: 'bypass',
      label: 'header.bypass',
      url: '/bypass',
      requiredRoles: ['bypass']
    },
    {
      key: 'cmt',
      label: 'header.wifi_management',
      url: '/event-ssids',
      requiredRoles: ['cmt']
    },
    {
      key: 'ssid-monitoring',
      label: 'ssid_monitoring.title',
      url: '/monitoring-ssids',
      requiredRoles: ['ssid_monitoring', 'ssid_monitoring_ro']
    },
    {
      key: 'access-point-zones',
      label: 'header.access-point-zones',
      url: '/access-point-zones',
      requiredRoles: ['access_point_zones']
    }
  ]
}

export const MENU_VOIP = {
  label: 'navigation.voip.title',
  key: 'voip',
  icon: 'phone',
  requiredRoles: ['voip'],
  menu: [
    {
      url: '/voip/dashboard',
      label: 'navigation.voip.dashboard.title',
    },
    {
      url: '/voip/sips',
      label: 'navigation.voip.sips.title',
    },
    {
      url: '/voip/cdrs',
      label: 'navigation.voip.cdrs.title',
    }
  ]
}

export const MENU_TV_CHROMECAST = {
  label: 'navigation.tv_chromecast.title',
  icon: 'tv',
  menu: [
    {
      url: '/stream-cast',
      label: 'navigation.tv_chromecast.stream_cast.title',
      requiredRoles: ['stream_cast'],
    },
    {
      url: '/iptv',
      label: 'navigation.tv_chromecast.iptv.title',
      requiredRoles: ['iptv_channels'],
    }
  ]
}

export const MENU_ADMIN = {
  label: 'navigation.admin.title',
  icon: 'user-group-simple',
  menu: [
    {
      label: 'navigation.contact_list.title',
      url: '/contacts',
      requiredRoles: ['admin_contact', 'admin_roles', 'readonly_contact']
    }, {
      label: 'navigation.mailer.title',
      url: '/mailer',
      requiredRoles: ['mailer']
    }, {
      label: 'navigation.admin_site.title',
      url: '/admin-sites',
      requiredRoles: ['admin_sites']
    }
  ]
}

export const MENU_CONTACTS = {
  label: 'navigation.contact_list.title',
  key: 'contacts',
  icon: 'user-group-simple',
  url: '/contacts',
  requiredRoles: ['admin_contact', 'admin_roles', 'readonly_contact']
}

export const MENU_MAILER = {
  label: 'navigation.mailer.title',
  key: 'mailer',
  icon: 'paper-plane',
  url: '/mailer',
  requiredRoles: ['mailer']
}

export const MENU_PROFILE = {
  label: 'navigation.profile.title',
  key: 'profile',
  icon: 'cog',
  url: '/profile'
}


export const MENU_SUPPORT = {
  label: 'navigation.support.title',
  key: 'support',
  icon: 'headset',
  menu: [{
    url: 'https://wifirst.my.site.com/supportpro',
    label: 'navigation.support.title',
    requiredRoles: ['requests'],
  }, {
    url: 'http://savel.mousquetaires.com/SRVS/CGI-BIN/WEBCGI.EXE?St=130,E=0000000000333234921,K=4786,Sxi=9,remove=problems,problem=obj(757455)',
    label: 'navigation.support.sav_stime.title',
    requiredRoles: ['sav_stime'],
  }]
}

export const MENU_EDA = {
  label: 'navigation.eda.title',
  key: 'eda',
  icon: 'shield-keyhole',
  menu: [{
    url: process.env.REACT_APP_ILOPEX_ADMIN_URL as string,
    label: 'ILOPEX',
    requiredRoles: ['ilopex']
  }, {
    url: process.env.REACT_APP_IDL_ADMIN_URL as string,
    label: 'IDL',
    requiredRoles: ['idl']
  }]
}

export const MENU_SILENT_MODE = {
  label: 'navigation.silent_mode.title',
  key: 'silent_mode',
  icon: 'comment-middle',
  menu: [{
    url: `${process.env.REACT_APP_ILOPEX_ADMIN_URL}/silent_mode`,
    label: 'ILOPEX',
    requiredRoles: ['ilopex']
  }, {
    url: `${process.env.REACT_APP_IDL_ADMIN_URL}/silent_mode`,
    label: 'IDL',
    requiredRoles: ['idl']
  }, {
    url: '/silent-mode',
    label: 'ILoSCA monde',
    requiredRoles: ['silent_mode']
  }]
}

export const ROUTE_GROUPS = {
  MONITORING: {
    base: '/monitoring/infras/hardwares',
    tabs: {
      base: '/monitoring/infras/hardwares',
      routes: [
        'blends',
        'access_points',
        'switches',
        'esls',
        'tvs',
        'chromecasts',
        'cctv_cameras',
        'cctv_servers'
      ]
    }
  }
}

export const MENU_PROJECTS = {
  label: 'header.projects',
  url: '/projects',
  key: 'projects',
  icon: 'clipboard-list-check',
  requiredRoles: ['project']
}